import { BaseApi } from "./base.api";

import {
  TAccountLeadAttributionCalculationConfig,
  TLeadAttributionByJourneyStatsDto,
  TLeadAttributionByOfficeStatsDto,
  TLeadAttributionBySourceStatsDto,
  TLeadAttributionByUtmCampaignStatsDto,
  TLeadAttributionPeopleDto,
} from "../types/account-lead-attribution-analyticis.type";
import { TSerializedDateRange } from "../types/date.type";
import { TLeadAttributionPeopleFilters } from "../store/UserAccounts/UserAccount/AccountAnalytics/AccountAnalyticsLeadAttributionStore/AccountAnalyticsLeadAttributionPeople.store";

export class AccountLeadAttributionAnalyticsApi extends BaseApi {
  // ACCOUNT LEAD ATTRIBUTION CALCULATION CONFIG
  async fetchAccountLeadAttributionCalculationConfig(
    accountId: number
  ): Promise<TAccountLeadAttributionCalculationConfig> {
    return this.get(
      `/accounts/${accountId}/lead-attribution-calculation-config`
    );
  }

  async updateAccountLeadAttributionCalculationConfig(
    accountId: number,
    leadAttributionCalculationConfig: TAccountLeadAttributionCalculationConfig
  ): Promise<TAccountLeadAttributionCalculationConfig> {
    return this.post(
      `/accounts/${accountId}/lead-attribution-calculation-config`,
      leadAttributionCalculationConfig
    );
  }

  //   STATS
  async fetchAccountLeadAttributionStatsByOffice(
    accountId: number,
    dateRange: TSerializedDateRange
  ): Promise<TLeadAttributionByOfficeStatsDto[]> {
    const { data } = await this.get(
      `/accounts/${accountId}/stats/attributions-by-office`,
      {
        params: {
          from: dateRange.startDate || undefined,
          to: dateRange.endDate || undefined,
        },
      }
    );

    return data;
  }

  async fetchAccountLeadAttributionStatsBySource(
    accountId: number,
    dateRange: TSerializedDateRange
  ): Promise<TLeadAttributionBySourceStatsDto[]> {
    const { data } = await this.get(
      `/accounts/${accountId}/stats/attributions-by-source`,
      {
        params: {
          from: dateRange.startDate || undefined,
          to: dateRange.endDate || undefined,
        },
      }
    );

    return data;
  }

  async fetchAccountLeadAttributionStatsByUTMCampaign(
    accountId: number,
    dateRange: TSerializedDateRange
  ): Promise<TLeadAttributionByUtmCampaignStatsDto[]> {
    const { data } = await this.get(
      `/accounts/${accountId}/stats/attributions-by-utm-campaign`,
      {
        params: {
          from: dateRange.startDate || undefined,
          to: dateRange.endDate || undefined,
        },
      }
    );

    return data;
  }

  async fetchAccountLeadAttributionStatsByJourney(
    accountId: number,
    dateRange: TSerializedDateRange
  ): Promise<TLeadAttributionByJourneyStatsDto[]> {
    const { data } = await this.get(
      `/accounts/${accountId}/stats/attributions-by-journey`,
      {
        params: {
          from: dateRange.startDate || undefined,
          to: dateRange.endDate || undefined,
        },
      }
    );

    return data;
  }

  async fetchLeadAttributionPeople(
    accountId: number,
    filters: TLeadAttributionPeopleFilters,
    afterKey: number | null,
    dateRange?: TSerializedDateRange,
    pageSize?: number
  ): Promise<TLeadAttributionPeopleDto> {
    return await this.get(
      `/accounts/${accountId}/stats/lead-attribution-people`,
      {
        params: {
          from: dateRange?.startDate || undefined,
          to: dateRange?.endDate || undefined,
          ...filters,
          afterKey: afterKey || undefined,
          pageSize: pageSize || undefined,
        },
      }
    );
  }
}
